module.exports = __webpack_public_path__ + "img/核心技术--人脸比对.b8d9c36d.png";